import { useSelector } from "react-redux";
import { RootState } from "..";
import { organisationSearchQueryToString } from "./util";
import { OrganisationSearchQueryState } from "../context/OrganisationSearchQuery";

export const useOrganisationSearchResult = (
  searchQuery: OrganisationSearchQueryState
) => {
  const organisationResult = useSelector(
    (s: RootState) => s.organisationResult
  );

  const queryString = organisationSearchQueryToString(searchQuery);

  console.log(organisationResult);
  console.log(queryString);

  return {
    ...organisationResult,
    data: organisationResult.data[queryString] || null,
  };
};
